module.exports = __webpack_public_path__ + "img/jiqi-guang.5cf67a4d.png";